import axios from "axios";

export const URL = "https://maisondesaromes-gspc.com/api/";
export const MEDIA_URL = "https://maisondesaromes-gspc.com/api";

export const setTokenWithExpiry = (token) => {
  const now = new Date();
  const expiryTime = now.getTime() + 3600 * 1000;
  const tokenData = {
    value: token,
    expiry: expiryTime,
  };

  localStorage.setItem("token", JSON.stringify(tokenData));
};

export const getToken = () => {
  const tokenData = localStorage.getItem("token");
  if (!tokenData) {
    return null;
  }
  const { value, expiry } = JSON.parse(tokenData);
  const now = new Date();
  if (now.getTime() > expiry) {
    localStorage.removeItem("token");
    return null;
  }

  if (!fetchUserProfile(value)) {
    localStorage.removeItem("token");
    return null;
  }

  // const value = "bbbabajkakakkkk:dhhhdjjj:ggagag";

  return value;
  // return true;
};

export const fetchUserProfile = async (token) => {
  try {
    const response = await axios.get(URL + "authentification/user-info", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;

    // const user = {
    //   username: "Ali",
    //   email: "ali02@gmail.com",
    // };

    // return user;
  } catch (err) {
    return null;
  }
};

export const getSimpleColor = function (x) {
  if (x >= 0.75) {
    return "rgb(20 184 166)";
  } else if (x >= 0.35) {
    return "rgb(251 146 60)";
  } else {
    return "rgb(248 113 113)";
  }
};

export const getBgColor = function (x) {
  if (x >= 0.75) {
    return "rgb(20 184 166/ var(--bg-opacity,1))";
  } else if (x >= 0.35) {
    return "rgb(251 146 60/ var(--bg-opacity,1))";
  } else {
    return "rgb(248 113 113/ var(--bg-opacity,1))";
  }
};

export const getColor = function (x) {
  if (x >= 0.75) {
    return "text-teal-500 border-teal-500";
  } else if (x >= 0.35) {
    return "text-orange-400 border-orange-400";
  } else {
    return "text-red-400 border-red-400";
  }
};

export const getLocalDate = function (date = new Date()) {
  if (!date) {
    return new Date().toLocaleDateString("fr-Fr", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  }

  let dateObj;

  // Si c'est une chaîne de caractères au format "YYYY-MM-DD"
  if (typeof date === "string") {
    if (date.match(/^\d{4}-\d{2}-\d{2}$/)) {
      const [year, month, day] = date.split("-");
      dateObj = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
    } else {
      dateObj = new Date(date);
    }
  } else {
    dateObj = date;
  }

  // Vérifier si la date est valide
  if (isNaN(dateObj.getTime())) {
    return "Date invalide";
  }

  const result = dateObj.toLocaleDateString("fr-Fr", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
  return result;
};

export const getLocalDateTime = function (date = new Date()) {
  return date.toLocaleDateString("fr-Fr", {
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

// function to add automatically 1000 separator to the number
export const formatNumber = (number) => {
  if (number === null || number === undefined) {
    return "";
  }
  const formattedNumber = new Intl.NumberFormat("fr-FR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(number);
  return formattedNumber;
};
